import React from "react";
import styled from "styled-components";
import colimage1 from "../images/fmcgpicking1.jpg";
import col2imagerow2 from "../images/ocf.webp";
import col2imagerowcol3 from "../images/latestinpic3.jpg";
import col2imagerow3 from "../images/LifeStyle1.jpg";
import LatestInsightsViewAll from "./LatestInsightsViewAll";
import ceoman from "../images/simonclic.png";

function LatestInsight() {
  return (
    <LatestInsightCon>
      <h2>Latest Insights</h2>
      <div>
        Access the latest articles, trends, and research to guide your strategy
        and keep you updated on what's new in the supply chain world.
        <br />
        <br />
      </div>
      <div className="LatestInSight" id="LatestInSight">
        <div>
          <div className="gallery-container">
            {/*this is for one object: start here */}
            <div className="gallery-iitem">
              <div className="image">
                <img src={colimage1} alt="" />
              </div>
              <span>
                <p>
                  Access the latest articles, trends, and research to guide your
                </p>
                <br />

                <div className="commanger">
                  <img src={ceoman} alt="" />
                  <div>
                    <div>Simone Obeng</div>
                    <div>CEO</div>
                  </div>
                </div>
              </span>
              <div className="text">FMCG</div>
            </div>
            {/*this is for one object: end here */}
          </div>
        </div>
        <div className="colgrid">
          <div className="gallery-container" style={{ gridColumn: "span 2" }}>
            {/*this is for one object: start here */}
            <div className="gallery-iitem">
              <div className="image">
                <img src={col2imagerow2} alt="" />
              </div>
              {/* <div className="text">Nature</div> */}
            </div>
            {/*this is for one object: end here */}
          </div>

          <div className="gallery-container">
            {/*this is for one object: start here */}
            <div className="gallery-iitem">
              <div className="image">
                <img src={col2imagerowcol3} alt="" />
              </div>
              {/*   <div className="text">Nature</div> */}
            </div>
            {/*this is for one object: end here */}
          </div>
          <div className="gallery-container">
            {/*this is for one object: start here */}
            <div className="gallery-iitem">
              <div className="image">
                <img src={col2imagerow3} alt="" />
              </div>
              {/*  <div className="text">Nature</div> */}
            </div>
            {/*this is for one object: end here */}
          </div>
        </div>
      </div>
      <br />
      <center>
        <button>
          <a href="/LatestInsightVallcon">View All</a>
        </button>
      </center>
      <br />
    </LatestInsightCon>
  );
}

export default LatestInsight;

const LatestInsightCon = styled.div`
  width: 75vw;
  margin-left: calc((100vw - 75vw) / 2);
  margin-right: calc((100vw - 75vw) / 2);

  .LatestInSight {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }

  .colgrid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
    gap: 20px;
  }

  .w-2 {
    grid-column: span 2;
  }

  .gallery-iitem {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
  }

  .gallery-iitem .image {
    width: 100%;
    height: 100%;
  }
  div .gallery-iitem .image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: 50% 50%;
    cursor: pointer;
    transition: 0.5s ease-in-out;
  }

  .gallery-iitem span {
    width: 100%;
    background: linear-gradient(to bottom, #333 10%, rgba(0, 0, 0, 0.4));
    position: absolute;
    bottom: -146px;
    height: 190px;
    padding: 20px 0px;
    left: 0px;
    color: white;
    z-index: 500;
    font-weight: bold;
    transition: 0.1s ease-in-out;
  }
  .gallery-iitem span p{

 cursor: pointer;
  }
 .gallery-iitem span .commanger{
 display: flex;
 }

  .gallery-iitem span .commanger div{
 padding: 2px;
 }
.gallery-iitem span .commanger img{
width: 60px;
height: 60px;
border-radius: 50%;
}

    .gallery-iitem:hover span {
      bottom: -50px;
    }

    .gallery-iitem:hover .image img {
      transform: scale(1.015);
    }

    .gallery-iitem .text {
      opacity: 0;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: white;
      font-size: 24px;
      pointer-event: none;
      z-index: 4;
      transition: 0.3 ease-in-out;
    }

    .gallery-iitem:hover .text {
      opacity: 1;
      animation: move-down 0.3s linear;
      padding: 1em;
      /*  outline:2px solid red; */
      -webkit-backdrop-filter: blur(5px) saturate(1.8);
      backdrop-filter: blur(5px) saturate(1.8);
    }

    @keyframes move-down {
      0% {
        top: 10%;
      }

      50% {
        top: 30%;
      }
    }
    100% {
      top: 50%;
    }
  }
`;
